/**
 * authEvents — tiny pub/sub for auth-lifecycle events that originate OUTSIDE
 * React (VH-119).
 *
 * The axios refresh-retry interceptor in `services/api.js` lives outside the
 * component tree, so when a token refresh ultimately fails it cannot call
 * React state setters directly. Instead it emits a "session expired" event
 * here; the `AuthProvider` subscribes and clears user state + tokens, which
 * causes the app to render the login screen via a *soft* SPA transition
 * (no `window.location` hard reload).
 */

const listeners = new Set()

/**
 * Subscribe to session-expired events. Returns an unsubscribe function.
 * @param {(reason?: string) => void} callback
 * @returns {() => void}
 */
export function onSessionExpired(callback) {
  listeners.add(callback)
  return () => listeners.delete(callback)
}

/**
 * Notify all subscribers that the session has expired and the user must be
 * logged out. Safe to call with no subscribers.
 * @param {string} [reason]
 */
export function emitSessionExpired(reason) {
  listeners.forEach((cb) => {
    try {
      cb(reason)
    } catch (err) {
      console.error('[authEvents] listener threw', err)
    }
  })
}
